// 定义内容
export default {
	card: {
		title1: '我的工作台',
		title2: '消息通知',
		title3: '更多',
		title4: '数据概览',
		title5: '更多',
		title6: '充值统计',
		title7: '统计图表',
		title8: '缺货监控',
		title9: '履约超时预警',
	},
};
